/**
 * 声音设置：picked 表示用户已经完成首次选择，enabled 表示当前是否播放声音。
 * picked 同时充当“体验已开始”的开关，WebGL 会在它为 true 后持续渲染动画。
 */
import { atom, useRecoilState } from 'recoil';

const soundConfigState = atom<{ picked: boolean; enabled: boolean }>({
    key: 'soundConfigState',
    default: {
        picked: false,
        enabled: false,
    },
});

export const useSoundConfigState = () => useRecoilState(soundConfigState);
